import { Tag } from "primereact/tag";

import { TipoObraTag } from "@/shared/components";

import { PROJECAO_LABEL, PROJECAO_PENDENTE } from "./escopo-cartao.constants";
import styles from "./escopo-cartao.module.scss";
import type { EscopoCartaoProps } from "./types-escopo-cartao";

export function EscopoCartaoView({
  rotulo,
  nome,
  tipoObraCodigo,
  classificacao,
  projecao,
  projecaoLabel = PROJECAO_LABEL,
  contexto,
  testIds,
}: EscopoCartaoProps) {
  return (
    <section className={styles.cartao} data-testid={testIds.cartao}>
      <div className={styles.topo}>
        <span className={styles.rotulo}>{rotulo}</span>
        <span className={styles.valorTotal} data-testid={testIds.projecao}>
          {projecaoLabel}: {projecao ?? PROJECAO_PENDENTE}
        </span>
      </div>
      <div className={styles.identificacao}>
        <TipoObraTag tipo={tipoObraCodigo} />
        <div className={styles.textos}>
          <strong className={styles.nome} data-testid={testIds.nome}>
            {nome}
          </strong>
          <span className={styles.contexto} data-testid={testIds.contexto}>
            {contexto}
          </span>
        </div>
        <Tag value={classificacao} severity="info" />
      </div>
    </section>
  );
}
